import { render, staticRenderFns } from "./NftCollectionCellRender.vue?vue&type=template&id=45f3a384&scoped=true"
import script from "./NftCollectionCellRender.vue?vue&type=script&lang=ts"
export * from "./NftCollectionCellRender.vue?vue&type=script&lang=ts"
import style0 from "./NftCollectionCellRender.vue?vue&type=style&index=0&id=45f3a384&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f3a384",
  null
  
)

export default component.exports